import { render, staticRenderFns } from "./CatergoryList.vue?vue&type=template&id=7b657437&scoped=true&"
import script from "./CatergoryList.vue?vue&type=script&lang=js&"
export * from "./CatergoryList.vue?vue&type=script&lang=js&"
import style0 from "./CatergoryList.vue?vue&type=style&index=0&id=7b657437&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b657437",
  null
  
)

export default component.exports